import { render, staticRenderFns } from "./seguro-para-moto-detalhamento.vue?vue&type=template&id=4829da84&"
import script from "./seguro-para-moto-detalhamento.vue?vue&type=script&lang=js&"
export * from "./seguro-para-moto-detalhamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports